import { ga } from 'js/analytics/adapters'

export const trackAccountFlowStep = ({
  step,
  scenario = '',
  couponCode = '',
  planDuration = null,
  entryPoint = '',
}) => {
  ga.track('account_flow_step', {
    step: step,
    scenario: scenario,
    coupon_code: couponCode,
    plan_duration: planDuration,
    entry_point: entryPoint,
  })
}
